export enum EditManualBankAccountModalState {
  Edit = 'edit',
  CreateForCsvImport = 'createForCsvImport',
}
